import React, { forwardRef, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

export const PasswordInput = forwardRef(function PasswordInput(
  {
    className = '',
    inputClassName = '',
    toggleTestId,
    testId,
    ...props
  },
  ref,
) {
  const [visible, setVisible] = useState(false);

  return (
    <div className={`relative ${className}`}>
      <input
        {...props}
        ref={ref}
        type={visible ? 'text' : 'password'}
        className={`${inputClassName} pr-12`}
        data-testid={testId}
      />
      <button
        type="button"
        onClick={() => setVisible((current) => !current)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-text-muted transition-colors hover:text-text-heading"
        aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        data-testid={toggleTestId}
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});